// extracted by mini-css-extract-plugin
export default {"backgroundAnimate":"MagazineCard_backgroundAnimate__kNs92","AnimationName":"MagazineCard_AnimationName__BynCu"};